/* eslint-disable import/order */
import React from 'react';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { manageProjectsDirectoryRoute } from '@jira/router-routes__directories-routes/src/manageProjectsDirectoryRoute.tsx';
import { ProjectsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { adminProjectDirectoryResources } from './common/adminProjectDirectoryResources.tsx';
import { LazyProjectsDirectory } from './common/LazyProjectsDirectory.tsx';
import { ProjectsDirectoryPageEntryPoint } from './common/ProjectsDirectoryPageEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const LazyAdminProjectsDirectory = () => <LazyProjectsDirectory isAdminProjectDirectoryRoute />;

const ProjectsDirectoryManageComponent = () => (
	<LazyPage
		Page={LazyAdminProjectsDirectory}
		pageId="projects-directory-manage-v3"
		shouldShowSpinner={false}
	/>
);

export const manageProjectsDirectoryRouteEntry: Route = createEntry(
	manageProjectsDirectoryRoute,
	() => ({
		group: 'directories',
		// eslint-disable-next-line no-restricted-syntax
		component: ProjectsDirectoryManageComponent,
		skeleton: ProjectsDirectorySkeleton,

		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
		},

		resources: [...getNavigationResources(), ...adminProjectDirectoryResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectsDirectory],
		ufoName: 'projects-directory-v3-manage',

		entryPoint() {
			return ProjectsDirectoryPageEntryPoint;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
